<template>
  <v-row v-if="totalPages > 1" class="justify-center">
    <v-pagination
      :model-value="currentPage"
      :length="totalPages"
      :total-visible="totalVisible"
      :color="activeColor"
      :density="density"
      class="pagination-component"
      @update:model-value="handlePageChange"
    />
  </v-row>
</template>

<script setup lang="ts">
  interface Props {
    currentPage: number;
    totalPages: number;
    totalVisible?: number;
    color?: string;
    activeColor?: string;
    density?: 'default' | 'comfortable' | 'compact';
  }

  const props = withDefaults(defineProps<Props>(), {
    totalVisible: 5,
    color: 'secondary',
    activeColor: 'primary',
    density: 'comfortable',
  });

  const emit = defineEmits<{
    (e: 'update:currentPage', value: number): void;
  }>();

  function handlePageChange(newPage: number) {
    emit('update:currentPage', newPage);
  }
</script>

<style scoped lang="scss">
  .pagination-component {
    margin: 32px 0 110px 0;
  }
</style>
